import { Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AttachmentIcon from '@material-ui/icons/Attachment';
import MessageIcon from '@material-ui/icons/Message';
import { Alert, AlertTitle } from '@material-ui/lab';
import { asDateTime, jumpToAnchor } from 'lqx-react';
import * as React from 'react';
import { useMemo } from 'react';
import { DisputeReason, InvoiceDispute } from 'api/dispute';
import { InvoiceModel } from 'api/invoice';
import { getChangedFieldsNames, getChangesCount } from '../../../../../common';

const compareJsonProperties = {
    includeAttr: [
        'parts'
    ]
};

const useStyles = makeStyles({
    root: {
        borderRadius: 2,
        backgroundColor: 'rgba(255,188,0,0.05)',
        border: '1px solid #FFBC00',

        color: '#000',
        fontFamily: 'Montserrat',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '17px',
    },

    title: {
        color: '#052C4C',
        fontFamily: 'Montserrat',
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '17px',
        textTransform: 'uppercase',
    },

    icon: {
        color: '#668AA5',
        marginRight: 5,
    },

    date: {
        color: '#767D84',
        fontFamily: 'Montserrat',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '14px',
        marginBottom: 16,
    },

    counter: {
        borderRadius: 2,
        backgroundColor: '#FFBC00',
        padding: '2px 8px',
        marginLeft: 5,
    },
});

export const UpdateSection = ({ prevInvoice, disputedInvoice }: { prevInvoice: InvoiceModel, disputedInvoice: InvoiceModel }) => {
    const classes = useStyles();
    let dispute: InvoiceDispute;
    const isSupplier = prevInvoice.isSupplier;
    const isWriteRole = (prevInvoice.isSupplierWrite || prevInvoice.isCustomerWrite);
    const isApproverRole = (prevInvoice.isSupplierApprover || prevInvoice.isCustomerApprover);
    if (disputedInvoice.invoiceStatus === 'ApprovalNeeded') {
        if (prevInvoice.hasActiveDispute) {
            dispute = prevInvoice.getActiveDispute;
        } else {
            const lastDispute = prevInvoice.disputes.last();
            if (lastDispute && (lastDispute.isUpdate || lastDispute.isOnlyInternalEscalationRejected)) {
                dispute = lastDispute;
            }
        }

    } else {
        dispute = prevInvoice.getActiveDispute;
    }

    // TODO: this should be refactored
    const data = useMemo(() => {
        if (!dispute ||
            (!dispute.isUserOnTheActiveSide && !dispute.isUpdate) ||
            (dispute.isOnlyInternalEscalation && isWriteRole) ||
            (dispute.isOnlyInternalEscalationRejected && isApproverRole) ||
            (dispute.isUpdate && isSupplier)
            ) {
            return undefined;
        }

        const lastEntry = dispute.history.last();
        if (!lastEntry) {
            return undefined;
        }

        const changesCount = getChangesCount(lastEntry.change);
        let disputeReason = DisputeReason[dispute.reason];
        if (dispute.reason === 'Changed') {
            const tmpInvoice = disputedInvoice.clone();
            if ( lastEntry.status === 'Rejected') {
                tmpInvoice.transaction(() => {
                        dispute.history.forEach(h => {
                            tmpInvoice.set(h.change, { parse: true, remove: false, merge: true });
                        });
                    });
            }
            disputeReason = getChangedFieldsNames(
                    prevInvoice.toJSON(compareJsonProperties),
                    tmpInvoice.toJSON(compareJsonProperties))
                .map(diff => InvoiceModel.diffNames[diff] || diff).join(', ');
        }

        const attachment = prevInvoice.uploads.get(lastEntry.attachmentId as any);

        return {
            attachment,
            disputeReason,
            changesCount,
            lastEntry
        };
    }, [(disputedInvoice as any)._changeToken]);

    return (
        data ?
            <Alert severity="warning" icon={ false } className={ classes.root }>
                <AlertTitle className={ classes.title }>
                    Updates
                    { data.changesCount ?
                        <span className={ classes.counter }>{ data.changesCount }</span>
                    : null }
                </AlertTitle>
                <span className={ classes.date }>{ asDateTime(data.lastEntry.createdOn) }</span>
                <div>
                    <span>Reason: </span>
                    { data.disputeReason }
                </div>

                <Link onClick={() => jumpToAnchor('all-activity')}>View changes</Link>

                { data.lastEntry.comment ?
                    <div>
                        <MessageIcon className={ classes.icon } />
                        { data.lastEntry.comment }
                    </div>
                : null }

                { data.attachment ?
                    <div>
                        <AttachmentIcon className={ classes.icon } />
                        <Link onClick={ () => data.attachment.download() }>{ data.attachment.file_name }</Link>
                    </div>
                : null }
            </Alert>
        : null
    );
};
